module.exports = __webpack_public_path__ + "static/paperYellow-eb9a7c46b72a628fe8c89dae371f1d06.svg";